import React from 'react';
import PropTypes from 'prop-types';

const defaultSteps = [
  { moduleName: 'NuxPicker' },
  { moduleName: 'NuxExtensionUpsell' },
  { moduleName: 'NuxEducationLoader' },
];

export default function withDefaultNuxSteps(Subject) {
  const defaultNuxSteps = function(props, context) {
    return <Subject {...props} steps={props.steps || defaultSteps} />;
  };

  defaultNuxSteps.propTypes = {
    steps: PropTypes.arrayOf(
      PropTypes.shape({
        moduleName: PropTypes.string.isRequired,
        options: PropTypes.shape({}),
      }),
    ),
  };

  return defaultNuxSteps;
}
